const theme = {

    $color_1: `#E0E0E0`,
    $color_2: `#000000`,
    $color_3: `#FFFFFF`,
    $color_4: `#F05A22`,
    $color_5: `#D6D6D6`,
    $color_6: `#454545`,
    $color_7: `#efefef`,
    $color_8: `#222222`,
    $color_9: `#5d5d5d`,

}

// event list tree in modal
theme['$eventListTreeModalBorderColor'] = theme['$color_1'];
theme['$eventListTreeModalColor'] = theme['$color_2'];
theme['$eventListTreeModalTabBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalScrollbarThumbBackgroundColor'] = theme['$color_4'];
theme['$eventListTreeModalEventDetailsBackgroundColor'] = theme['$color_1'];
theme['$eventListTreeModalCategoryTabBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalMarkActiveEventBackgroundColor'] = theme['$color_4'];
theme['$eventListTreeModalEventBorderBottomColor'] = theme['$color_3'];
theme['$eventListTreeModalSetResultColor'] = theme['$color_4'];
theme['$eventListTreeModalTabSportNameBackgroundColor'] = theme['$color_1'];
theme['$eventListTreeModalCategoryLevel3BtnsHeaderBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalEventDetailsPrematchBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalEventDetailsPrematchBorderColor'] = theme['$color_1'];
theme['$eventListTreeModalTabCategoryNameBackgroundColor'] = theme['$color_3'];
theme['$eventListTreeModalCategoryLevel3PrematchBtnsHeaderBackgroundColor'] = theme['$color_5'];

// game type group filter with categories

theme['$groupFilterCategoryContainerBgColor'] = theme['$color_7'];
theme['$groupFilterBtnFilterBackgroundColor'] = theme['$color_3'];
theme['$groupFilterBtnFilterTextColor'] = theme['$color_6'];
theme['$groupFilterBtnFilterTextActiveColor'] = theme['$color_4'];
theme['$groupFilterCategoryNameColor'] = theme['$color_8'];
theme['$groupFilterCountTextColor'] = theme['$color_8'];
theme['$groupFilterCheckboxBorderColor'] = theme['$color_9'];
theme['$groupFilterCheckboxActiveBorderColor'] = theme['$color_4'];
theme['$groupFilterCheckboxActiveCheckColor'] = theme['$color_3'];
theme['$groupFilterBorderColor'] = theme['$color_3'];
theme['$groupFilterButtonActiveBgColor'] = theme['$color_4'];
theme['$groupFilterButtonTextActiveColor'] = theme['$color_3'];
theme['$groupFilterButtonClearBgColor'] = theme['$color_3'];

export default theme;